import { ReactNode } from 'react';
import {
  GlobeAsiaAustraliaIcon,
  ServerStackIcon,
} from '@heroicons/react/24/outline';
import { Tooltip } from '../tooltip';

export type AssetHeaderTextProps = {
  label: string;
  className?: string;
  isGlobeIcon?: boolean;
  lg?: boolean;
  icon?: ReactNode;
  text?: string;
};

export const AssetHeaderText = ({
  label,
  className,
  isGlobeIcon,
  icon,
  lg,
  text,
}: AssetHeaderTextProps) => {
  if (!text) {
    return <></>;
  }
  return (
    <Tooltip label={label}>
      <div
        className={`flex items-center px-1 whitespace-nowrap text-gray-500 dark:text-gray-400 ${
          lg ? 'text-sm' : 'text-xs'
        }`}
      >
        {isGlobeIcon ? (
          <GlobeAsiaAustraliaIcon className="h-4 px-1" />
        ) : (
          icon || <ServerStackIcon className="h-4 px-1" />
        )}
        <span className={className || ''}>{text}</span>
      </div>
    </Tooltip>
  );
};
